import React, { useState, useEffect } from "react";
import { useDispatch, connect } from "react-redux";
import constants from "../../../constants";
import Input from "../../FormElements/Input";
import UploadField from "../../FormElements/UploadField";

import GlobalViewFileModal from "../../../services/GlobalViewFileModal";
import { redirectUrl } from "../../../services/GlobalUrls";
import { checkIfFileIsaDocument } from "../../../services/FileOperationGlobalFunctions";
const Resume = (props) => {
  const [modalOption, setModalOption] = useState(false);
  const [modalHeight, setModalHeight] = useState("500px");
  const [fileUrl, setFileUrl] = useState("");
  const dispatch = useDispatch();
  const [fileName, setFileName] = useState("");
  const { errors, userInfo, onChange } = props;
  const [formdata, setFormdata] = useState({
    cnd_upload_cv: "",
    cnd_upload_cover: "",
    cnd_upload_dbs: "",
    users_access_token: "",
  });
  const [title, setTitle] = useState("");

  const handleChange = (e) => {
    if (e.target?.name) {
      setFormdata((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    }
    onChange(e);
  };

  const viewFileModal = (url, st1) => {
    setTitle("Personal Information - " + st1);
    if (checkIfFileIsaDocument(url)) {
      setModalHeight("500px");
      // setFileName(fileName);
      setFileUrl(url);
    } else {
      redirectUrl(url);
    }
  };
  const callModal = () => {
    document.getElementById("loader").style.display = "block";
    setModalOption(true);
  };
  const loaderEnd = () => {
    document.getElementById("loader").style.display = "none";
    setModalHeight("auto");
  };
  const closeFileModal = () => {
    setModalOption(false);
    setFileUrl("");
  };

  return (
    <React.Fragment>
      <div className="submit-resume container mt-3">
        {/* <div className="job-bx-title clearfix">
          <h5 className="font-weight-700 pull-left text-uppercase">
            Upload Cover Letter & CV
          </h5>
          {/* <Link to={"./"} className="site-button right-arrow button-sm float-right">Back</Link> 
        </div> */}
        {window.location.pathname == "/permanent-job-profile" && (
          <div className="row m-b30 text-danger">
            {/* Cover Letter Start */}
            <UploadField
              label="Upload Cover Letter"
              id="cnd_upload_cover"
              changeHandler={handleChange}
              name="cnd_upload_cover"
              value={formdata.cnd_upload_cover || userInfo?.cnd_upload_cover || ""}
              lg={6}
              req={false}
              errors={errors}
              acceptedTypes={["pdf", "image", "doc"]}
            />
            {userInfo.cnd_cover_forderpath &&
              userInfo.cnd_upload_cover.substr(0, 5) != "data:" && (
                <div className="col-lg-6 col-md-6">
                  <label>Download/View</label>
                  <div className="form-group hover">
                    <a
                      onClick={() =>
                        viewFileModal(
                          userInfo.cnd_cover_forderpath
                            ? constants.IMAGE_URL +
                                userInfo.cnd_cover_forderpath +
                                userInfo.cnd_upload_cover
                            : "#",
                          "Uploaded Cover Letter"
                        )
                      }
                      // target="_blank"
                      className="cursor-pointer"
                    >
                      {(userInfo &&
                        userInfo.cnd_upload_cover &&
                        userInfo.cnd_upload_cover.endsWith(".png")) ||
                      userInfo.cnd_upload_cover.endsWith(".jpg") ||
                      userInfo.cnd_upload_cover.endsWith(".jpeg") ||
                      userInfo.cnd_upload_cover.endsWith(".pdf") ? (
                        <h6 class="text-dark">
                          <i className="fa fa-eye f-26 btn-sm text-white bg-dark"></i>
                          <span>
                            {/*userInfo.cnd_upload_cover*/} View Cover Letter
                          </span>
                        </h6>
                      ) : (
                        <h6 class="text-primary">
                          <i className="fa fa-download f-26"></i>
                          <span>
                            {/*userInfo.cnd_upload_cover*/} Download Cover
                            Letter
                          </span>
                        </h6>
                      )}
                    </a>
                  </div>
                </div>
              )}
          </div>
        )}

        {/* Cover Letter End */}

        {/* CV Start */}

        <div className="row m-b30 text-danger">
          <UploadField
            label="Upload CV"
            id="cnd_upload_cv"
            changeHandler={handleChange}
            name="cnd_upload_cv"
            value={formdata.cnd_upload_cv || userInfo?.cnd_upload_cv || ""}
            lg={6}
            req={true}
            errors={errors}
            acceptedTypes={["pdf", "image", "doc"]}
          />
          {userInfo.cnd_cv_forderpath &&
            userInfo.cnd_upload_cv.substr(0, 5) != "data:" && (
              <div className="col-lg-6 col-md-6">
                <label>Download/View</label>
                <div className="form-group hover">
                  <a
                    onClick={() =>
                      viewFileModal(
                        userInfo.cnd_cv_forderpath && userInfo.cnd_upload_cv
                          ? constants.IMAGE_URL +
                              userInfo.cnd_cv_forderpath +
                              userInfo.cnd_upload_cv
                          : "#",
                        "Uploaded CV"
                      )
                    }
                    // target="_blank"
                    className="cursor-pointer"
                  >
                    {(userInfo &&
                      userInfo.cnd_upload_cv &&
                      userInfo.cnd_upload_cv.endsWith(".png")) ||
                    userInfo.cnd_upload_cv.endsWith(".jpg") ||
                    userInfo.cnd_upload_cv.endsWith(".jpeg") ||
                    userInfo.cnd_upload_cv.endsWith(".pdf") ? (
                      <h6 class="text-dark">
                        <i className="fa fa-eye f-26 btn-sm text-white bg-dark"></i>
                        <span>{/*userInfo.cnd_upload_cv*/} View CV</span>
                      </h6>
                    ) : (
                      <h6 class="text-primary">
                        <i className="fa fa-download f-26"></i>
                        <span>{/*userInfo.cnd_upload_cv*/} Download CV</span>
                      </h6>
                    )}
                  </a>
                </div>
              </div>
            )}
        </div>
        {/* <br /><br /><br /> */}
        {/* DBS Start */}

        {window.location.pathname == "/permanent-job-profile" && (
          <div className="row m-b30 text-danger">
            <UploadField
              label="Upload DBS Certificate"
              id="cnd_upload_dbs"
              changeHandler={handleChange}
              name="cnd_upload_dbs"
              value={formdata.cnd_upload_dbs || userInfo?.cnd_upload_dbs || ""}
              lg={6}
              req={false}
              errors={errors}
              acceptedTypes={["pdf", "image", "doc"]}
            />
            {userInfo.cnd_dbs_forderpath &&
              userInfo.cnd_upload_dbs.substr(0, 5) != "data:" && (
                <div className="col-lg-6 col-md-6">
                  <label>Download/View</label>

                  <div className="form-group hover">
                    <a
                      onClick={() =>
                        viewFileModal(
                          userInfo.cnd_dbs_forderpath
                            ? constants.IMAGE_URL +
                                userInfo.cnd_dbs_forderpath +
                                userInfo.cnd_upload_dbs
                            : "#",
                          "Uploaded DBS Certificate"
                        )
                      }
                      // target="_blank"
                      className="cursor-pointer"
                    >
                      {(userInfo &&
                        userInfo.cnd_upload_dbs &&
                        userInfo.cnd_upload_dbs.endsWith(".png")) ||
                      userInfo.cnd_upload_dbs.endsWith(".jpg") ||
                      userInfo.cnd_upload_dbs.endsWith(".jpeg") ||
                      userInfo.cnd_upload_dbs.endsWith(".pdf") ? (
                        <h6 class="text-dark">
                          <i className="fa fa-eye f-26  btn-sm text-white bg-dark "></i>
                          <span>{/*userInfo.cnd_upload_dbs*/} View DBS</span>
                        </h6>
                      ) : (
                        <h6 class="text-primary">
                          <i className="fa fa-download f-26"></i>
                          <span>
                            {/*userInfo.cnd_upload_dbs*/} Download DBS
                          </span>
                        </h6>
                      )}
                    </a>
                  </div>
                </div>
              )}
          </div>
        )}

        {/* DBS Stop */}
      </div>
      <GlobalViewFileModal
        modalOption={modalOption}
        closeFileModal={closeFileModal}
        fileUrl={fileUrl}
        loaderEnd={loaderEnd}
        modalHeight={modalHeight}
        callModal={callModal}
        title={title}
        // fileName={fileName}
      />
    </React.Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    userAuth: state.auth.authUserData,
    userInfo: state.userProfile.userData,
    workPrefrences: state.workPrefrences.workPrefrences,
    loader: state.loader.loader,
  };
};

export default connect(mapStateToProps)(Resume);
